import { action, get } from '@/lib/api.js';

const getCredentialImpact = async ({ companyId, credentialId }) => {
  action('SET_CREDENTIAL_IMPACT', { companyId, credentialId, status: 'loading', rows: [] });
  const rows = await get(`v1/credentials/${credentialId}/impact`, {
    query: { companyId },
    action: 'GET_CREDENTIAL_IMPACT'
  });
  action('SET_CREDENTIAL_IMPACT', {
    companyId,
    credentialId,
    status: Array.isArray(rows) ? 'loaded' : 'unavailable',
    rows: Array.isArray(rows) ? rows : []
  });
};

export default getCredentialImpact;
